/**
 * Event name when the dropdown is changed
 */
export const AD_PATHWAYS_EVENT = 'adPathwaysEvent';
